import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { IssueModuleAccess } from '../module-access/issues-module-access';

function BlockIssuesRoute(): boolean {
    // If company uses HubSpot, block /issues route
    return inject(IssueModuleAccess).usesHubspot();
}

export const issuesHubspotBlockGuard: CanActivateFn = (): boolean | UrlTree => {
    const router = inject(Router);
    return BlockIssuesRoute() ? router.parseUrl('/') : true;
};

export const issuesHubspotBlockChildGuard: CanActivateChildFn = (): boolean | UrlTree => {
    const router = inject(Router);
    return BlockIssuesRoute() ? router.parseUrl('/') : true;
};
